import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ComboboxItem, ComboboxItemContent, ComboboxItemTitle } from "@opensea/ui-kit";
import { ItemAvatar } from "../avatar/ItemAvatar";
import { useSetItemQuickView } from "../item-page/ItemViewModal/use-set-item-quick-view";
import { CollectionItemSearchItemFragment } from "./CollectionItemSearchItem.fragment";
export function CollectionItemSearchItem(t0) {
  const $ = _c(15);
  const {
    item: itemKey,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(CollectionItemSearchItemFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  const setItem = useSetItemQuickView();
  let t2;
  if ($[2] !== item || $[3] !== onSelect || $[4] !== setItem) {
    t2 = () => {
      onSelect();
      setItem(item);
    };
    $[2] = item;
    $[3] = onSelect;
    $[4] = setItem;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== item) {
    t3 = <ItemAvatar className="rounded" item={item} size={24} />;
    $[6] = item;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== item.name) {
    t4 = <ComboboxItemContent><ComboboxItemTitle className="truncate">{item.name}</ComboboxItemTitle></ComboboxItemContent>;
    $[8] = item.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== item.tokenId || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <ComboboxItem key={item.tokenId} onSelect={t2} value={item.tokenId}>{t3}{t4}</ComboboxItem>;
    $[10] = item.tokenId;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}